'use strict';

var Carousel = require('client/components/carousel');
var scrollAnimate = require('base/components/scrollAnimate');

/**
 * Updates url parameter valuue
 *
 * @param {string} param - param whose value needs to be updated
 * @param {string} newval - newval with which the param value is replaced with
 * @param {string} search - page URL query string
 * @return {undefined}
 */
function replaceQueryParam(param, newval, search) {
    var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
    var query = search.replace(regex, '$1').replace(/&$/, '');

    return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
}

/**
 * Returns a map of query string params with key as param name and val as param value
 *
 * @param {string} url - page URL
 * @return {undefined}
 */
function getUrlParamObj(url) {
    var params = {};
    var paramStr = url.slice(url.indexOf('?') + 1);
    var definitions = paramStr.split('&');

    definitions.forEach(function (val) {
        var parts = val.split('=', 2);
        params[parts[0]] = parts[1];
    });

    return params;
}

/**
 * Adds selected facets to page URL
 * @param {string} href - facet AJAX URL
 * @return {undefined}
 */
function updatePageURLForFacets(href) {
    var urlParams = href.slice(href.indexOf('?') + 1);

    if (history.pushState) {
        var url = document.location.href + '?' + urlParams;
        if (document.location.href.indexOf('?') > -1) {
            url = document.location.href.substring(0, document.location.href.indexOf('?')) + '?' + urlParams;
        }
        window.history.pushState({ path: url }, '', url);
    }
}

/**
 * Adds selected sort rule to page URL
 *
 * @param {string} href - facet AJAX URL
 * @return {undefined}
 */
function updatePageURLForSortRule(href) {
    var hrefparams = getUrlParamObj(href);
    var urlparams = getUrlParamObj(document.location.href);
    var urlStr = document.location.search;

    Object.keys(urlparams).forEach(function (urlkey) {
        Object.keys(hrefparams).forEach(function (hrefkey) {
            if (hrefkey === 'cgid') {
                return;
            }
            var hrefval = hrefparams[hrefkey];
            if (urlkey === hrefkey) {
                urlStr = replaceQueryParam(urlkey, hrefval, urlStr);
            } else if (urlparams[hrefkey] === undefined && urlStr.indexOf(hrefkey) === -1) {
                if (urlStr.indexOf('?') > -1) {
                    urlStr = urlStr + '&' + hrefkey + '=' + hrefval;
                } else {
                    urlStr = urlStr + '?' + hrefkey + '=' + hrefval;
                }
            }
        });
    });

    if (history.pushState) {
        var url = document.location.href.substring(0, document.location.href.indexOf('?')) + urlStr;
        window.history.pushState({ path: url }, '', url);
    }
}

/**
 * Adds page start and size to page URL for show more
 *
 * @param {string} showMoreUrl - facet AJAX URL
 * @return {undefined}
 */
function updatePageURLForShowMore(showMoreUrl) {
    var params = getUrlParamObj(showMoreUrl);
    var start = params.start;
    var size = params.sz;
    var newSize = parseInt(start) + parseInt(size);
    var url;

    if (history.pushState) {
        if (document.location.href.indexOf('?') > -1) {
            if (document.location.href.indexOf('sz=') > -1) {
                var tempUrlParams = document.location.search;
                tempUrlParams = replaceQueryParam('sz', newSize, tempUrlParams);
                url = document.location.href.substring(0, document.location.href.indexOf('?')) + tempUrlParams;
            } else {
                url = document.location.href + '&start=0&sz=' + newSize;
            }
        } else {
            url = document.location.href + '?start=0&sz=' + newSize;
        }
        window.history.pushState({ path: url }, '', url);
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * function to play video on page load
 */
function autoplayTilesVideo() {
    $('.image-container-video').each(function () {
        var $this = $(this);

        if (!$this.find('.image-container-hover').length) {
            var player = new Vimeo.Player($this.find('iframe'), { // eslint-disable-line
                muted: true,
                autopause: false
            });

            player.play();
        }
    });
}

/**
 * function to play video on hover
 */
function playVideoHover() {
    $('.image-container-video .image-container-hover').on('mouseenter', function () {
        var $this = $(this);

        var player = new Vimeo.Player($this.find('iframe'), { // eslint-disable-line
            muted: true,
            autopause: false
        });

        player.play();
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @param {boolean} avoidUpdateSearchResult - Avoid the update related to search result
 * @return {undefined}
 */
function parseResults(response, avoidUpdateSearchResult) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    if (!avoidUpdateSearchResult) {
        // Update DOM elements that do not require special handling
        [
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar'
        ].forEach(function (selector) {
            updateDom($results, selector);
        });
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Apply filters for click events.
 *
 * @param {Object} applyButton - HTML or jQuery element.
 * @param {boolean} callingFromFilterSelection - Flag indicating if the function was called by filter selection.
 */
function applyFilterClickEvent(applyButton, callingFromFilterSelection) {
    var $this = callingFromFilterSelection ? applyButton : $(applyButton),
        $checkedFilters = $this.prev('.refinements').find('.refinements-dropdown-item .selected:not(.refinements-dropdown-price)'),
        $priceFilter = $this.prev('.refinements').find('.refinements-dropdown-price.selected'),
        baseUrl = $this.data('url') + '&',
        filterObject = {},
        filterIndex = 0,
        $sortOptions = $('.sort-order-option'),
        endUrl = '';

    if ($('.container.search-results').find('.selected').length > 0) {
        $('.page').addClass('show-clear-all');
    } else {
        $('.page').removeClass('show-clear-all');
    }

    $checkedFilters.each(function () {
        var $filterLink = $(this).closest('.refinements-dropdown-item'),
            filterId = $filterLink.data('id'),
            filterVal = $filterLink.data('value');

        if (typeof filterObject[filterId] === 'undefined') {
            filterObject[filterId] = [];
        }
        filterObject[filterId].push(filterVal);
    });

    $.each(filterObject, function (key, value) {
        filterIndex++;
        endUrl += '&prefn' + filterIndex + '=' + key + '&prefv' + filterIndex + '=' + value.join('|');
    });

    if ($priceFilter.length > 0) {
        var $priceFilterLink = $priceFilter.closest('.refinements-dropdown-item');
        endUrl += '&pmin=' + parseInt($priceFilterLink.data('pmin'), 10) + '&pmax=' + parseInt($priceFilterLink.data('pmax'), 10);
    }

    baseUrl += endUrl;

    $sortOptions.each(function () {
        var thisVal = $(this).data('initialval');
        $(this).attr('value', thisVal += endUrl);
        if (Object.keys(filterObject).length > 0 || $priceFilter.length > 0) {
            $(this).data('filterapplied', true);
        } else {
            $(this).data('filterapplied', false);
        }
    });

    $.ajax({
        url: baseUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: baseUrl
        },
        method: 'GET',
        success: function (response) {
            parseResults(response, callingFromFilterSelection);

            if (callingFromFilterSelection) {
                $('.pulsing-logo').addClass('d-none');
            } else {
                $('#refinement-bar-modal').modal('hide');
                $this.closest('.refinements-hover-dropdown').addClass('d-none');

                $(document).trigger('search:updated');
                $(document).trigger('gtm:search:filter:apply');

                // hide featured and full width content blocks, but not for portfolio pages
                $('.two-by-two').not(':has(.portfolio)').addClass('d-none');
                $('.one-by-three').addClass('d-none');

                if (!$('.grid-tile').length) {
                    $('.empty-filter-page').removeClass('d-none');
                } else {
                    $('.empty-filter-page').addClass('d-none');
                }

                // Hide clear all filters
                if (!$('.refinements').find('.selected').length) {
                    $('.page').removeClass('show-clear-all');
                }
                autoplayTilesVideo();
                playVideoHover();
            }
            // Custom Start: Update URL Params
            updatePageURLForFacets(baseUrl);
            // custom End
        },
        error: function () {
            $('.pulsing-logo').addClass('d-none');
        }
    });
}

module.exports = {
    init: function () {
        var event = {
            name: 'gtm:pageLoad',
            handler: 'portfolio'
        };

        if (window.queuedGtmEvents) {
            window.queuedGtmEvents.push(event);
        } else {
            window.queuedGtmEvents = [event];
        }
    },

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            var $sortButton = $(this).hasClass('sort-option') ? $('.popup-sort-btn') : $('.popup-filter-btn');

            $('#refinement-bar-modal').modal('show');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();

            $sortButton.trigger('click');
        });
    },

    closeRefinments: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('#refinement-bar-modal').modal('hide');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('#refinement-bar-modal').modal('hide');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('click', '.sort-order-option', function (e) {
            var $this = $(this),
                urlValue = $this.attr('value'),
                filterApplied = $this.data('filterapplied');
            e.preventDefault();

            $this.trigger('search:sort', urlValue);
            $.ajax({
                url: urlValue,
                data: {
                    selectedUrl: urlValue,
                    showMoreFeatureCount: 0,
                    showMoreFullWidthCount: 0
                },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);

                    $('#refinement-bar-modal').modal('hide');
                    $this.closest('.refinements-hover-dropdown').addClass('d-none');

                    $(document).trigger('search:updated');
                    $(document).trigger('search:sort:complete');

                    if (filterApplied) {
                        // hide featured and full width content blocks
                        $('.two-by-two').addClass('d-none');
                        $('.one-by-three').addClass('d-none');
                    }
                    // Custom Start: Update URL Params
                    updatePageURLForSortRule(urlValue);
                    // Custom End

                    var scrollTo = $('#maincontent');
                    scrollAnimate($(scrollTo));

                    autoplayTilesVideo();
                    playVideoHover();
                },
                error: function () {
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url'),
                showMoreFeatureVal = $(this).data('feature-count'),
                showMoreFullWidthVal = $(this).data('fullwidth-count');

            e.preventDefault();

            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl,
                    showMoreFeatureCount: showMoreFeatureVal,
                    showMoreFullWidthCount: showMoreFullWidthVal
                },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $(document).trigger('search:updated');
                    // Custom Start: Update URL Params
                    updatePageURLForShowMore(showMoreUrl);
                    // Custom end
                    autoplayTilesVideo();
                    playVideoHover();
                },
                error: function () {
                }
            });
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html().trim() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinement-bar .reset-filter-button, .filter-value button, .swatch-filter button',
            function (e) {
                var $this = $(this),
                    $sortOptions = $('.sort-order-option'),
                    filtersResetTriggered = $this.hasClass('reset-filter-button');
                e.preventDefault();
                e.stopPropagation();

                $(this).trigger('search:filter', e);
                $('.empty-filter-page').addClass('d-none');
                var filtersURL = $(this).data('href');

                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);

                        if (!$this.hasClass('mobile-clear-button')) {
                            $('#refinement-bar-modal').modal('hide');
                        } else {
                            $this.removeClass('w-50').addClass('d-none');
                            $('.refinements-apply-button').removeClass('w-50').addClass('d-none');
                        }

                        $('.refinements-apply-button').removeClass('btn-primary').addClass('btn-outline-primary');

                        $(document).trigger('search:updated');
                        $(document).trigger('gtm:search:filter:apply');

                        // show featured and full width content blocks
                        $('.two-by-two').removeClass('d-none');
                        $('.one-by-three').removeClass('d-none');

                        $sortOptions.each(function () {
                            $(this).data('filterapplied', false);
                            if (filtersResetTriggered) {
                                $(this).attr('value', $(this).data('initialval'));
                            }
                        });

                        autoplayTilesVideo();
                        playVideoHover();

                        // hide clear all filter button
                        $('.page').removeClass('show-clear-all');
                        // Custom Start: Update URL Params
                        updatePageURLForFacets(filtersURL);
                        // custom End
                    },
                    error: function () {
                    }
                });
            });
    },

    appplyActiveFilter: function () {
        $(document).on('click', '.refinements li button', function () {
            var $this = $(this),
                $refWrapper = $this.closest('.refinements'),
                $applyButton = $refWrapper.next('.refinements-apply-button'),
                $filterResetBtn = $('.refinements-clear-button');

            $('body').find('.filter li').css({ opacity: 0.5, 'pointer-events': 'none' });
            $('.pulsing-logo').removeClass('d-none');

            $this.find('.refinements-name').toggleClass('selected');
            $this.find('.refinements-dropdown-checkbox').toggleClass('d-none');

            enquire.register('screen and (max-width: ' + globalConfig.bp.small + 'px)', {
                match: function () {
                    if ($refWrapper.find('.selected').length) {
                        $applyButton.removeClass('d-none');
                    } else {
                        $applyButton.addClass('d-none').removeClass('w-50');
                        $filterResetBtn.addClass('d-none');
                    }
                }
            }).register('screen and (min-width: ' + (globalConfig.bp.medium + 1) + 'px)', {
                match: function () {
                    $applyButton.removeClass('w-50');

                    if ($refWrapper.find('.selected').length) {
                        $applyButton.removeClass('btn-outline-primary').addClass('btn-primary');
                    } else {
                        $applyButton.removeClass('btn-primary').addClass('btn-outline-primary');
                    }
                }
            });

            applyFilterClickEvent($applyButton, true);
        });
    },

    filterModal: function () {
        $('#refinement-bar-modal').on('show.bs.modal', function () {
            var filterModalSelects = $(this).find('.refinements .selected').length,
                $filterApplyBtn = $('.refinements-apply-button'),
                $filterResetBtn = $('.refinements-clear-button'),
                gridLength = $('.product-grid').find('.grid-tile').length;

            $filterResetBtn.addClass('d-none w-50');

            if (filterModalSelects) {
                $filterResetBtn.removeClass('d-none');
                $filterApplyBtn.addClass('w-50').removeClass('d-none');
            } else {
                $filterResetBtn.addClass('d-none');
                $filterApplyBtn.removeClass('w-50').addClass('d-none');
            }

            if (!gridLength) {
                $filterResetBtn.removeClass('d-none w-50');
            }
        });
    },

    filterModalTabs: function () {
        $('.refinements-modal-title').on('click', function () {
            var $this = $(this);
            var $refMobileModal = $('#refinement-bar-modal');

            $refMobileModal.find('.refinements-modal-tab .refinements-hover-dropdown').removeClass('d-none');

            if (!$(this).hasClass('active')) {
                $refMobileModal.find('.refinements-modal-title').removeClass('active');
                $(this).addClass('active');
            }

            if ($this.hasClass('popup-sort-btn')) {
                $('.refinements-modal-sort').removeClass('d-none');
                $('.refinements-modal-filter').addClass('d-none');
            } else {
                $('.refinements-modal-sort').addClass('d-none');
                $('.refinements-modal-filter').removeClass('d-none');
            }
        });
    },

    applyFilterCollection: function () {
        $(document).on('click', '.refinements-apply-button', function () {
            applyFilterClickEvent(this);
        });
    },

    changeGridView: function () {
        $('.grid-view').on('click', function () {
            var $gridWrapper = $('.grid-products-wrapper'),
                bLazy = new Blazy(); // eslint-disable-line

            if ($(this).attr('data-items-inrow') === '3') {
                $gridWrapper.removeClass('five-items-view');

                window.dataLayer.push({
                    event: 'plpViewChange',
                    items_in_row: 3
                });
            } else {
                $gridWrapper.addClass('five-items-view');
                $(document).trigger('search:updated');

                window.dataLayer.push({
                    event: 'plpViewChange',
                    items_in_row: 5
                });
            }

            $(this).closest('.refinements-hover-dropdown').addClass('d-none');
        });
    },

    initCustomCarousel: function () {
        var $topBannerPlpCarousel = new Carousel('topBannerPlpCarousel');
        $topBannerPlpCarousel.activate();
    },

    initPortfolioCarousel: function () {
        var $portfolioSearchCarousel = new Carousel('portfolioCarousel');
        $portfolioSearchCarousel.activate();
    },

    initPortfolioModalCarousel: function () {
        var $slider = $('.portfolio-modal-carousel'),
            $portfolioModal = $('#portfolioModal'),
            currentSlide,
            slidesCount,
            $sliderCounter = $('<div class="slider-counter"></div>');

        // Add counter for modal slider
        var update$sliderCounter = function (slick) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $($sliderCounter).text(currentSlide + '/' + slidesCount);
        };

        $slider.on('init', function (event, slick) {
            $('.slider-counter-wrapper').append($sliderCounter);
            update$sliderCounter(slick);
        });

        $slider.on('afterChange', function (event, slick, currentSlide) { // eslint-disable-line
            update$sliderCounter(slick, currentSlide);
        });

        var $portfolioModalCarousel = new Carousel('portfolioModalCarousel');
        $portfolioModalCarousel.activate();

        // Modal events
        $('.portfolio-carousel .slide').click(function () {
            $slider.slick('slickGoTo', $(this).data('slickIndex'));
            $portfolioModal.modal('show');
        });

        $portfolioModal.on('shown.bs.modal', function () {
            $('.carousel.portfolio-modal-carousel').slick('refresh');
        });

        $portfolioModal.on('show.bs.modal', function () {
            $('body').addClass('static');
        });

        $portfolioModal.on('hide.bs.modal', function () {
            $('body').removeClass('static');
        });
    },

    initVideoEvents: function () {
        autoplayTilesVideo();
        playVideoHover();
    },

    refinementsEvents: function () {
        $('.refinements-trigger').on('mouseenter touchstart', function () {
            $(this).find('.refinements-hover-dropdown').removeClass('d-none');
        });

        $('.refinements-trigger').on('mouseleave', function () {
            $(this).find('.refinements-hover-dropdown').addClass('d-none');
        });
    },

    breadcrumbsEvents: function () {
        $('.breadcrumb-trigger').on('mouseenter', function () {
            $(this).find('.breadcrumb-hover-dropdown').removeClass('d-none');
        });

        $('.breadcrumb-trigger').on('mouseleave', function () {
            $(this).find('.breadcrumb-hover-dropdown').addClass('d-none');
        });

        $('.breadcrumb-hide-dropdown').on('click', function (e) {
            e.preventDefault();

            $(this).closest('.breadcrumb-hover-dropdown').addClass('d-none');
        });
    },

    refinementModalEvents: function () {
        $('#refinement-bar-modal, #breadcrumbModal').on('shown.bs.modal', function () {
            var $stickyRefinements = $('.refinements-sticky');

            if ($stickyRefinements.length) {
                $stickyRefinements.addClass('refinements-sticky-overflow');
            }
        });

        $('#refinement-bar-modal, #breadcrumbModal').on('hide.bs.modal', function () {
            var $stickyRefinements = $('.refinements-sticky');

            if ($stickyRefinements.length) {
                $stickyRefinements.removeClass('refinements-sticky-overflow');
            }
        });
    }
};
